import React from 'react';
import Icon from '../Icon';

export const CHART_COLORS = ['#037b90', '#3b82f6', '#10b981', '#f59e0b', '#8b5cf6', '#ec4899', '#06b6d4', '#84cc16', '#f97316', '#6366f1'];

export const RANGES = [
  { value: 'all', label: 'All time' },
  { value: 'last_7_days', label: '7D' },
  { value: 'last_30_days', label: '30D' },
  { value: 'last_90_days', label: '90D' },
  { value: 'current_month', label: 'This month' },
  { value: 'last_month', label: 'Last month' },
  { value: 'current_year', label: 'This year' },
  { value: 'custom', label: 'Custom' }
];

export const greetingFor = (hour) => {
  if (hour < 12) return 'Good morning';
  if (hour < 17) return 'Good afternoon';
  return 'Good evening';
};

export const formatTimeAgo = (dateString) => {
  if (!dateString) return '';
  const now = new Date();
  const date = new Date(dateString);
  const diffMins = Math.floor((now - date) / 60000);
  const diffHours = Math.floor(diffMins / 60);
  const diffDays = Math.floor(diffHours / 24);
  if (diffMins < 1) return 'Just now';
  if (diffMins < 60) return `${diffMins}m ago`;
  if (diffHours < 24) return `${diffHours}h ago`;
  if (diffDays < 7) return `${diffDays}d ago`;
  return date.toLocaleDateString();
};

export function DeltaChip({ value, suffix = '%' }) {
  if (value === undefined || value === null) return null;
  const up = value >= 0;
  return (
    <span className={`delta ${up ? 'delta-up' : 'delta-down'}`}>
      <Icon name={up ? 'trending-up' : 'trending-down'} />
      {up ? '+' : ''}{value}{suffix} <span style={{ opacity: 0.7, fontWeight: 400 }}>vs prev</span>
    </span>
  );
}

export function KpiTile({ label, value, delta, icon, color }) {
  return (
    <div className="kpi-tile">
      <div className="kpi-top">
        <div>
          <div className="kpi-label">{label}</div>
          <div className="kpi-value">{value}</div>
        </div>
        <div className="kpi-icon" style={{ background: `${color}1a`, color }}>{icon}</div>
      </div>
      {delta !== undefined && delta !== null && <DeltaChip value={delta} />}
    </div>
  );
}

export function FilterBar({ range, onRange, customStart, setCustomStart, customEnd, setCustomEnd, onApplyCustom, periodLabel }) {
  return (
    <div className="filter-bar">
      <span className="filter-label"><Icon name="calendar" /> Period:</span>
      {RANGES.filter((r) => r.value !== 'custom').map((r) => (
        <button key={r.value} className={`filter-pill ${range === r.value ? 'active' : ''}`} onClick={() => onRange(r.value)}>
          {r.label}
        </button>
      ))}
      <button className={`filter-pill ${range === 'custom' ? 'active' : ''}`} onClick={() => onRange('custom')}>Custom</button>
      {range === 'custom' && (
        <span className="custom-range">
          <input type="date" className="form-input" value={customStart} onChange={(e) => setCustomStart(e.target.value)} />
          <span>→</span>
          <input type="date" className="form-input" value={customEnd} onChange={(e) => setCustomEnd(e.target.value)} />
          <button className="btn btn-primary btn-sm" onClick={onApplyCustom}>Apply</button>
        </span>
      )}
      {periodLabel && range !== 'custom' && <span className="filter-current">{periodLabel}</span>}
    </div>
  );
}

export function GreetingHero({ greeting, name, actions }) {
  return (
    <div className="analytics-hero">
      <div>
        <div className="hero-greeting">{greeting},</div>
        <div className="hero-name">Welcome back, {name}</div>
        <div className="hero-date">{new Date().toLocaleDateString(undefined, { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })}</div>
      </div>
      <div className="hero-actions">{actions}</div>
    </div>
  );
}

export function ActivityFeed({ items, emptyText = 'No recent activity.' }) {
  return (
    <div className="activity-feed">
      {(!items || items.length === 0) && <p style={{ color: '#94a3b8', padding: '12px' }}>{emptyText}</p>}
      {items && items.map((n, i) => (
        <div key={n.id || i} className="activity-item">
          <div className="activity-title">{n.title}</div>
          {n.message && <div className="activity-desc">{n.message}</div>}
          {n.status && <div className="activity-desc">Status: {n.status}</div>}
          <div className="activity-time">{formatTimeAgo(n.created_at || n.timestamp || n.date)}</div>
        </div>
      ))}
    </div>
  );
}

export function SectionCard({ title, subtitle, action, children }) {
  return (
    <div className="card">
      <div className="card-header">
        <div><h2 className="card-title">{title}</h2>{subtitle && <p className="card-subtitle">{subtitle}</p>}</div>
        {action}
      </div>
      {children}
    </div>
  );
}
